export default{
    title: 'light',

    colors:{
        primary: '#712831',
        secundary: '#94A3B8',

        background: '#fff',
        text: '#636466',
        buttonText: '#fff',


        shadow: '0 2px 24px rgb(57 140 235 / 42%)',

        backgroundpresentation: '#fff',
        backgroundpresentation780: '#fff',
    }
}